import { render, staticRenderFns } from "./RegulationItem.vue?vue&type=template&id=4ec92284&"
import script from "./RegulationItem.vue?vue&type=script&lang=js&"
export * from "./RegulationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports